<template>
  <div>
    <title>商品列表</title>
    <section class="goodsBox">
        <!--S 检索-->
        <el-form :model="searchGLForm" inline class="searchForm">
            <el-form-item label="快递生成日期">
                <!-- S 双日期选择器 -->
                <TwoDatePicker
                    @twoDateObtain="outDateReceive"
                    :startvaldate="searchGLForm.outTime.length>0?searchGLForm.outTime[0]:''"
                    :endvaldate="searchGLForm.outTime.length>0?searchGLForm.outTime[1]:''"
                    key="out">
                </TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item label="发货日期">
                <!-- S 双日期选择器 -->
                <TwoDatePicker
                    @twoDateObtain="orderDateReceive"
                    :startvaldate="searchGLForm.orderTime.length>0?searchGLForm.orderTime[0]:''"
                    :endvaldate="searchGLForm.orderTime.length>0?searchGLForm.orderTime[1]:''"
                    key="orderTime">
                </TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item label=" 快递单号">
                <el-input v-model="searchGLForm.expno" placeholder="请输入内容" clearable maxlength="16"></el-input>
            </el-form-item>
            <el-form-item label="发货状态">
                <el-select v-model="searchGLForm.deliverstate" multiple collapse-tags placeholder="请选择或输入" clearable>
                    <el-option label="待发货" :value="0"></el-option>
                    <el-option label="已发货" :value="1"></el-option>
                    <el-option label="退货" :value="2"></el-option>
                    <el-option label="已补发" :value="3"></el-option>
                    <el-option label="无效快递" :value="4"></el-option>
                    <el-option label="已签收" :value="5"></el-option>
                    <el-option label="异常签收" :value="6"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="querySubmit">查询</el-button>
                <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
                <em class="simpleSearch" style="cursor: pointer;" @click="highShow = !highShow">{{highShow?'精简筛选':'高级筛选'}}</em>
            </el-form-item>
            <div class="none" :class="{'block':highShow}">
                <el-form-item label="快递处理方式">
                    <ExpressHandleMode :isHandleMode="searchGLForm.handletype" @handleModeObtain="handleModeObtain"></ExpressHandleMode>
                </el-form-item>
                <el-form-item label="订单号" class="codeSerIpt">
                    <el-input v-model="searchGLForm.orderno" placeholder="请输入订单号" clearable ></el-input>
                </el-form-item>
                <el-form-item label="是否为首发快递">
                    <el-select v-model="searchGLForm.bnew" filterable placeholder="请选择或输入" clearable>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
            </div>
        </el-form>
        <!--E 检索-->
        <!-- 注意：有合并表头样式的table，这里要加类名borderIndiv -->
        <div class="gsListTable individualiz borderIndiv">
            <el-form :model="searchGLForm" inline size="medium">
                <el-form-item>
                    <el-button type="primary" plain @click="specMange = true" v-show="!exportShow">任务列表</el-button>
                    <el-button type="primary" plain @click="groupShow = true" v-show="!exportShow">归类统计</el-button>
                    <el-button type="primary" plain v-show="!exportShow" @click="openExport">导出</el-button>
                    <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(0)">检索导出</el-button>
                    <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(1)">勾选导出</el-button>
                    <el-button type="danger" v-show="exportShow" icon="el-icon-close" round @click="closeExport">取消</el-button>
                </el-form-item>
            </el-form>
            <!--S 列表-->
            <!-- 注意：有合并表头样式的table要加类名borderTable -->
            <el-table ref="gsTable" class="gsTable comTable borderTable" border :data="expressStatisticsList" :maxHeight="tableHeight" @selection-change="handleSelectionChange" v-loading="loading">
                <el-table-column v-if="exportShow" type="selection" width="100"></el-table-column>
                <el-table-column type="index" label="序号" width="80" fixed="left"></el-table-column>
                <el-table-column label="快递单号" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.expno">{{scope.row.expno | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="订单号" min-width="230">
                    <template slot-scope="scope">
                        <p :title="scope.row.orderno">{{scope.row.orderno}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="母单号" min-width="230">
                    <template slot-scope="scope">
                        <p :title="scope.row.forderno">{{scope.row.forderno}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="快递生成日期" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.expgendate}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="快递内容" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.expcontent">{{scope.row.expcontent}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="收货人" min-width="150">
                    <template slot-scope="scope">
                        {{scope.row.receivername | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="收货人联系方式" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.receivertel">{{scope.row.receivertel | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="备用号码" min-width="150">
                    <template slot-scope="scope">
                        {{scope.row.othtel | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="持卡人联系方式" min-width="150">
                    <template slot-scope="scope">
                        {{scope.row.cardholdertel | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="地址" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="期望发货日期动态" min-width="200">
                    <template slot-scope="scope">
                        {{scope.row.recvdate}}
                    </template>
                </el-table-column>
                <el-table-column label="快递方式" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.exptypeName | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="快递费用（￥）" min-width="150">
                    <template slot-scope="scope">{{scope.row.expmoney | empty}}</template>
                </el-table-column>
                <el-table-column label="快递生成类型" min-width="150">
                    <template slot-scope="scope">
                        {{scope.row.expgentypeName}}
                    </template>
                </el-table-column>
                <el-table-column label="快递处理方式" min-width="150">
                    <template slot-scope="scope">
                        {{scope.row.handletypeName}}
                    </template>
                </el-table-column>
                <el-table-column label="发货状态" min-width="120">
                    <template slot-scope="scope">
                        <span :class="[{'orangeColor':scope.row.deliverstate=='待发货'},{'blueColor': scope.row.deliverstate=='已发货'},{'redColor':scope.row.deliverstate=='退货'},{'greenColor':scope.row.deliverstate=='已补发' },{'greyColor':scope.row.deliverstate=='无效快递' }]">{{scope.row.deliverstate?scope.row.deliverstate:'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="发货方" min-width="200">
                    <template slot-scope="scope">
                       <p class="textHiden" :title="scope.row.shippername"> {{scope.row.shippername | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="发货时间" min-width="180">
                    <template slot-scope="scope">
                        {{scope.row.deliverdate | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="是否为首发快递" min-width="180">
                    <template slot-scope="scope">
                        {{scope.row.bnewName | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="上级快递单号" min-width="200">
                    <template slot-scope="scope">
                        {{scope.row.fexpno | empty}}
                    </template>
                </el-table-column>
                 <el-table-column label="买家备注" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.buyermemo">{{scope.row.buyermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="卖家备注" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sellermemo">{{scope.row.sellermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="快递备注" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.expmemo">{{scope.row.expmemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="打印状态" min-width="120">
                    <template slot-scope="scope">
                        <p :class="[{'orangeColor':scope.row.bprintName=='待打印'},{'blueColor':scope.row.bprintName=='已打印'}]">{{scope.row.bprintName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="筛单状态" min-width="120">
                    <template slot-scope="scope">
                        <p :class="[{'orangeColor':scope.row.screenstateName=='待筛单'},{'blueColor':scope.row.screenstateName=='筛单处理成功'},{'redColor':scope.row.screenstateName=='筛单处理失败' || scope.row.screenstateName=='筛单处理异常'}]">{{scope.row.screenstateName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="顺丰热敏下单类型" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.ordtypeName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="子单号" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.childno | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="签单返回单号" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.backno | empty}}</p>
                    </template>
                </el-table-column>
                <template slot="empty">
                  <div class="noData"><span>暂无数据</span></div>
                </template>
            </el-table>
            <!--E 商品列表-->
        </div>
        <!-- S 分页 -->
        <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
        <!-- S 分页 -->
    </section>
    <!-- S 任务列表弹窗 -->
    <TaskList :isStatistics="1" :specMange="specMange" :eleType="4" @closeTask="closeTask"></TaskList>
    <!-- E 任务列表弹窗 -->
    <!--S 归类统计-->
    <el-dialog :visible.sync="groupShow" class="comDlog seniorMdg" append-to-body :close-on-click-modal="false">
        <div slot="title" class="dialog-title">归类统计</div>
        <el-form :model="groupForm" label-width="100px">
            <el-form-item label="归类依据">
                <el-select v-model="groupForm.group" filterable placeholder="请选择或输入" clearable>
                    <el-option
                      v-for="(item,index) in groupList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                      :title="item.label">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="openGroup(1)">确定</el-button>
            <el-button @click="openGroup(0)">取消</el-button>
        </div>
    </el-dialog>
    <!--E 归类统计-->
    <!-- S 归类统计列表 -->
    <ExpressClassifyStatistics :classifyValue="groupForm.group" :cateType="0" :queryParams="queryParams" :groupDetailShow="groupDetailShow" @closePop="closeCstatis"></ExpressClassifyStatistics>
    <!-- E 归类统计列表 -->
  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
    name:'ExpressStatisticsDetail',
    data () {
        return {
            currentTit:0, //当前选中菜单
            highShow: false, //是否展示高级筛选
            groupShow: false,//归类统计弹窗
            searchGLForm:{
                outTime: [], // 出库时间段
                orderTime: [], // 发货时间段
                expno: '', // 快递单号
                handletype: '', // 快递处理方式
                orderno: '', // 订单号
                deliverstate: [], // 发货状态
                bnew: '', // 是否为首发快递
            },
            tableHeight: window.innerHeight*.8, //表格动态高度
            specMange:false, //任务列表弹窗
            groupForm:{
                group:''
            },//归类统计弹窗
            groupList:[
                { value: "deliverstate", label: "发货状态" },
                { value: "bnew", label: "是否为首发快递" },
                { value: "handletype", label: "快递处理方式" },
            ],//归类统计
            pageSize: 30, // 每页展示的条数
            currentPage: 1, // 当前请求的页数
            pagebBean: {
                totalnum: 0,
            }, // 获取到的列表分页信息
            expressStatisticsList: [], // 券卡统计详情列表
            exportShow: false, // 是否为导出操作
            multipleSelection: [], // 选中的列表数据
            printingShow: true, // 防止多次点击导出按钮
            groupDetailShow:false,//归类统计详情弹窗显隐
            queryParams: '', // 归类列表查询参数
            loading: false, // 加载中弹窗显示和隐藏
        }
    },
    filters: {
    },
    components: {
        Page: resolve => require(["@/components/common/Page.vue"], resolve),
        TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
        TaskList: resolve =>require(["@/components/StatisticsFolder/TaskList.vue"], resolve), // 任务列表组件
        ExpressClassifyStatistics: resolve =>require(["@/components/StatisticsFolder/ExpressClassifyStatistics.vue"], resolve), // 归类统计列表组件
        ExpressHandleMode: resolve =>require(["@/components/Gadget/ExpressHandleMode.vue"], resolve), // 快递处理方式组件
    },
    // ============================================== 监听 ==============================================
    watch: {
        
    },
    // ============================================== 方法 ==============================================
    methods: {
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
            this.tableHeight = window.innerHeight - tbHeight - 130; 
        },
        // 接收选中的出库日期
        outDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.outTime[0] = info[0];
                this.searchGLForm.outTime[1] = info[1];
            } else {
                this.searchGLForm.outTime = [];
            }
        },
        // 接收选中的发货日期
        orderDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.orderTime[0] = info[0];
                this.searchGLForm.orderTime[1] = info[1];
            } else {
                this.searchGLForm.orderTime = [];
            }
        },
        // 返回请求参数
        returnQueryInfo() {
            let detailParams = {
                startdate: this.searchGLForm.outTime.length>0?this.dateTime(this.searchGLForm.outTime[0]):'',
                enddate: this.searchGLForm.outTime.length>0?this.dateTime(this.searchGLForm.outTime[1]):'',
                stardeldate: this.searchGLForm.orderTime.length>0?this.dateTime(this.searchGLForm.orderTime[0]):'',
                enddeldate: this.searchGLForm.orderTime.length>0?this.dateTime(this.searchGLForm.orderTime[1]):'',
                expno: this.searchGLForm.expno,
                handletype: this.searchGLForm.handletype,
                orderno: this.searchGLForm.orderno,
                deliverstate: this.searchGLForm.deliverstate,
                bnew: this.searchGLForm.bnew,
            };
            return detailParams;
        },
        // 获取快递统计详情列表
        getExpstatisticsDetail() {
            this.loading = true;
            let detailParams = this.returnQueryInfo();
            detailParams.pageparam = {
                pagesize: this.pageSize, //每页条数
                currentpage: this.currentPage, //当前页数
                isnewcomp: 1 //是否需要重新统计页数
            }
            api.GET_EXPSTATISTICSDETAIL(detailParams).then(res => {
                this.loading = false;
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data !='null') {
                        this.expressStatisticsList = res.data.data;
                    } else {
                        this.expressStatisticsList = [];
                    }
                    this.pagebBean = res.data.pagebean;
                }
            }).catch(res => {
                this.loading = false;
            })
        },
        // 接收分页信息
        updatePage(size,num) {
            this.pageSize = size;
            this.currentPage = num;
            this.getExpstatisticsDetail();
        },
        // 检索确定事件
        querySubmit() {
            this.currentPage = 1;
            this.getExpstatisticsDetail();
        },
        // 打开归类选择弹窗
        openGroup(type) {
            if(type == 1) {
                if(!this.groupForm.group) {
                    this.$message({
                        type: 'warning',
                        message: '请选择归类依据！'
                    })
                    return false;
                }
                // 获取归类统计列表
                this.queryParams = this.returnQueryInfo();
                this.groupDetailShow = true;
            } else {
                this.groupForm.group = '';
                this.groupShow = false;
            }
        },
        // 导出操作显示
        openExport() {
            this.exportShow = true;
        },
        // 取消导出
        closeExport() {
            this.multipleSelection = [];
            this.$refs.gsTable.clearSelection(); // 清空选中列表数据
            this.exportShow = false;
        },
        // 打印操作确认事件
        toPrinting(type) {
            if(this.printingShow) {
                let queryParams = this.returnQueryInfo();
                if(type == 1) {
                    if(this.multipleSelection&&this.multipleSelection.length>0) {
                        queryParams.exceltype = 1;
                        let alltotales = '';
                        this.multipleSelection.forEach(item => {
                            if(alltotales!=='') {
                                alltotales = alltotales + ',' + item.expcode;
                            } else {
                                alltotales = item.expcode;
                            }
                        })
                        this.loading = true;
                        this.printingShow = false;
                        queryParams.alltotale = alltotales;
                        this.getUrlForExpstatisticsDetail(queryParams);
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '请至少勾选一项！'
                        })
                    }
                } else {
                    this.loading = true;
                    this.printingShow = false;
                    queryParams.exceltype = 0;
                    this.getUrlForExpstatisticsDetail(queryParams);
                }
            }
        },
        // 获取兑换礼券统计详细列表信息下载地址
        getUrlForExpstatisticsDetail(params) {
            api.GET_URLFOREXPSTATISTICSDETAIL(params).then(res => {
                this.printingShow = true;
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data.indexOf('http')!=-1) {
                        window.location.href = res.data.data;
                        this.$message({
                            type: 'success',
                            message: res.data.message
                        })
                        this.closeExport();
                    } else {
                        MessageBox.confirm(`${res.data.data}`, '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'success'
                        }).then(() => {
                            this.closeExport();
                        }).catch(() => {})
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
                this.loading = false;
            }).catch(res => {
                this.loading = false;
                this.printingShow = true;
            })
        },
        //表格多选选中行复制
        handleSelectionChange(val) { 
            this.multipleSelection = val;
        },
        // 关闭任务列表弹窗
        closeTask() {
            this.specMange = false;
        },
        // 关闭归类统计列表
        closeCstatis() {
            this.groupForm.group = '';
            this.groupShow = false;
            this.groupDetailShow = false;
        },
        // 获取快递处理方式的值
        handleModeObtain(val) {
            this.searchGLForm.handletype = val;
        }
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
        let startDate = new Date();
        let endDate = new Date();
        startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 365);
        if(sessionStorage.getItem('ticsQueryInfo')&&sessionStorage.getItem('ticsQueryInfo')!=undefined) {
            let ticsQueryInfo = JSON.parse(sessionStorage.getItem('ticsQueryInfo'));
            setTimeout(() => {
                if(ticsQueryInfo.eleType!=-1) {
                    this.searchGLForm.deliverstate.push(ticsQueryInfo.eleType);
                }
                this.searchGLForm.outTime = ticsQueryInfo.paiTime!=undefined?(ticsQueryInfo.paiTime.length>0?ticsQueryInfo.paiTime:[startDate,endDate]):[startDate,endDate];
            }, 305);
        };
        setTimeout(() => {
            this.getExpstatisticsDetail();
        }, 310);
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)

    },
    computed: {},
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
@import '../../GoodsFolder/Css/style.css';
.goodsBox {padding:20px; height:calc(100% - 40px);}
.gsTable em{
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    width: 20px;
    color:
    #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-left: 10px;
}
.gsTable .orange{background-color: #FF7018;}
.gsTable .blue{background-color: var(--main-color);}
.gsTable .iconhand::before {
    font-size: 20px;
    padding-right: 5px;
    display: inline-block;
    vertical-align: top;
}
.gsTable >>> .el-table__header .el-form-item {margin-bottom:0!important;}
.goodsUse {position:relative;height:36px;padding-right:15px;border-right:solid 1px #dcdfe6;}
.goodsUse em {position:absolute; left:0; top:-20px; font-size: 12px; color:#999;}
.gsTable.el-table >>> thead.is-group > tr:first-child th .cell{overflow: visible!important;}
.gsTable.el-table >>> thead.is-group > tr:nth-child(2) th .cell {color:#333;}
.gsTable.el-table >>> .el-table__body .el-checkbox {padding:20px;}
.gsTable.el-table >>> .el-table__header .el-checkbox {padding:0 20px;}
.gsTable >>> .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.inlineMember {padding:0 10px; border:solid 1px #dcdfe6; height:38px; line-height:38px;}
.childView.takeLeft .inlineMember,.childView.helpRight .inlineMember {margin-top:0px;}
@media only screen and (max-width: 1700px) {
  .inlineMember {margin-top:10px;} 
}
.inlineMember a:first-child {position:relative; width:30px; height:30px; margin:3px 0; border-radius:50%; overflow: hidden; border:solid 1px #ebeef5; }
.inlineMember img {position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; width:30px; }
.inlineMember * {display:inline-block; vertical-align: top; font-size: 14px;}
.inlineMember span {margin-right:10px;}
.inlineMember i {color:#999;}
.inlineMember em {max-width:150px; width: auto;}
.inlineMember .iconmale {font-size: 18px;color:var(--main-color);}
.inlineMember .iconfemale {font-size: 18px;color:#f56c6c;}
.goodsImg{
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  border: solid 1px #dcdfe6;
  border-radius:100%;
  margin-right:10px;
}
.goodsImg img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: 100%;
  border-radius: 50%;
}
.goodsCont h3{font-size:14px!important;font-weight:bold;}
.goodsCont p{font-size:12px;}
.goodsCont{width: calc(100% - 65px);}
.actShow {padding-top:10px; color:#999;  font-size: 12px;}
.actShow span {display:inline-block; margin-right:35px;}
.actShow span b {font-weight: 600; padding-right:5px;}
/*归类统计弹窗*/
.seniorMdg >>> .el-dialog {width:500px;}
.seniorMdg >>> .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.seniorMdg >>> .el-form-item__content .el-select {width:100%;}
.none{display: none;}
.block{display: block;}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/ExpressStatistics/ExpressStatisticsDetail.vue